module.exports = __webpack_public_path__ + "media/images/modules/publisher/tabs/video_letter--active-58843583629484dd432af0631a1ab542.png";